import { useQuery } from '@apollo/client';
import { parseQueryString, OptionalString, updateQueryString } from '@sixfold/app-utils';
import { Stack } from '@sixfold/common-ui';
import { useLocation, useNavigate } from 'react-router';

import { InfiniteScroll } from '../../components/infinitescroll';
import {
  UserListQuery,
  UserListQueryVariables,
  getNodes,
  loadMoreFromConnection,
  PAGINATION_PAGE_SIZE,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { UserList, UserListDataProps } from '../components/user_list';
import { UsersFilter } from '../components/users_filter';
import { usersQuery } from '../graphql';

class LoadingContainer extends Loader<UserListQuery, UserListDataProps, UserListQueryVariables> {}

export const UserListContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { searchInput } = parseQueryString({
    queryString: location.search,
    queryParametersToParse: {
      searchInput: OptionalString,
    },
  });

  const result = useQuery<UserListQuery, UserListQueryVariables>(usersQuery, {
    fetchPolicy: 'cache-and-network',
    variables: {
      limit: PAGINATION_PAGE_SIZE,
      search: searchInput,
    },
  });

  return (
    <Stack direction="column" gap="medium" style={{ height: 'calc(100vh - 100px)' }}>
      <UsersFilter
        activeFilters={{ searchInput }}
        onFilterToggle={({ name, value }) => {
          void navigate(
            `${location.pathname}?${updateQueryString(location.search, {
              param: name,
              value,
            })}`,
          );
        }}
        onClearFilters={() => void navigate(location.pathname)}
      />
      <LoadingContainer
        result={result}
        options={{
          showLoadingPlaceholder: ({ networkStatus, loading }) => {
            const isFetchingMore = networkStatus === 3;
            return isFetchingMore ? false : loading;
          },
        }}
        mapData={({ data }) => ({ data: { users: getNodes(data.users) } })}>
        {({ data }) => (
          <InfiniteScroll
            className="user-list"
            triggerOnWindow={false}
            loadMoreEntries={() => loadMoreFromConnection(usersQuery, result, ['users'])}>
            <UserList data={data} />
          </InfiniteScroll>
        )}
      </LoadingContainer>
    </Stack>
  );
};
